import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import {createStore, applyMiddleware, compose} from 'redux';
import {Provider} from 'react-redux';
import createSagaMiddleware from 'redux-saga';
// import { createLogger } from "redux-logger";
// import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer, {rootSaga} from 'modules';
import {SCREEN_WIDTH, M_VOD_AFREECATV_DOMAIN} from 'constants/config';
import {isCheckBrowser, isCheckPlatform} from 'lib/utils';
import App from './App';
import CheckBrowser from 'components/common/modal/CheckBrowser';
import packageInfo from '../package.json';
import {i18nReady, t} from 'lib/i18n';
const {name: NAME, version: VERSION} = packageInfo;

// 번역 로드 완료 후 초기화
(async () => {
  try {
    // i18n 로딩 대기
    await i18nReady;
  } catch (error) {
    console.error('Failed to load i18n, continuing anyway:', error);
  }

  // document title setting
  document.title = t('SOOP VOD 편집기');

  console.log(`${NAME}: v${VERSION}`); // 버전 출력

  const isPlatform = isCheckPlatform(); // 모바일은 미지원
  if (!isPlatform) {
    alert(t('PC 환경에서 편집 가능합니다.'));
    window.location.href = M_VOD_AFREECATV_DOMAIN;
  }

  const isSupport = isCheckBrowser(); // 크롬/웨일 브라우저인지 체크
  if (!isSupport) {
    ReactDOM.render(<CheckBrowser />, document.querySelector('body'));
  } else {
    const sagaMiddleware = createSagaMiddleware();

    let store = undefined as any;
    if (process.env.NODE_ENV === 'development') {
      // 개발 모드에서는 redux-logger랑 devtools 활성화
      const {createLogger} = await import('redux-logger');
      const {composeWithDevTools} = await import('redux-devtools-extension');
      const logger = createLogger();
      store = createStore(
        rootReducer,
        composeWithDevTools(applyMiddleware(logger, sagaMiddleware)),
      );
    } else {
      store = createStore(
        rootReducer,
        compose(applyMiddleware(sagaMiddleware)),
      );
    }

    sagaMiddleware.run(rootSaga);

    const webeditor = document.getElementById('webeditor');
    if (webeditor) {
      webeditor.style.width = `${SCREEN_WIDTH}px`; // 유저단 해상도 기준으로 너비 설정
    }

    ReactDOM.render(
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>,
      webeditor,
    );
  }
})();
